import { motion } from "framer-motion";
import { ShieldCheck, HeartPulse, Flame, Map } from "lucide-react";
import { ItalyRegionsMap } from "@/components/site/ItalyRegionsMap";

const REGIONS = [
  "Valle d'Aosta 118",
  "Piemonte 118",
  "Lombardia · AREU 118",
  "Friuli Venezia Giulia 118",
  "Veneto · SUEM 118",
  "Liguria 118",
  "Toscana 118",
  "Marche 118",
  "Abruzzo 118",
  "Sardegna · AREUS 118",
  "Basilicata 118",
  "Calabria 118",
];

const CERTS = [
  {
    icon: ShieldCheck,
    name: "ARES 118",
    label: "Accreditamento regionale · aggiornato 2026",
    detail: "Delibera 335 del 26/07/2016 · Regione Lazio",
  },
  {
    icon: Flame,
    name: "Certificazione FGAS",
    label: "Credenziale distinta",
    detail: "Gestione gas fluorurati · percorso dedicato",
  },
  {
    icon: HeartPulse,
    name: "American Heart Association",
    label: "Affiliazione didattica",
    detail: "Standard internazionale AHA",
  },
  {
    icon: Map,
    name: "Altri accreditamenti regionali",
    label: "Struttura estendibile",
    detail: "Predisposto per accreditamenti in altre regioni",
  },
];

export const Certifications = () => {
  return (
    <section data-testid="certifications-section" className="py-16 md:py-20 bg-white border-b border-border">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-red mb-3">
              Certificazioni e accreditamenti
            </div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tighter text-brand-black">
              Credenziali chiare, pronte a crescere regione per regione.
            </h2>
          </div>
          <p className="max-w-sm text-sm text-brand-ink leading-relaxed">
            Una griglia estendibile: ARES 118, FGAS e AHA oggi, nuovi accreditamenti regionali domani.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
          {CERTS.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.name}
                data-testid={`cert-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group flex items-start gap-4 border border-border p-5 hover:border-brand-red transition-colors"
              >
                <div className="w-14 h-14 shrink-0 rounded-full border-2 border-brand-red flex items-center justify-center text-brand-red group-hover:bg-brand-red group-hover:text-white transition-colors">
                  <Icon size={24} />
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.18em] text-brand-ink">
                    {c.label}
                  </div>
                  <div className="font-heading font-bold text-lg text-brand-black leading-tight">
                    {c.name}
                  </div>
                  <div className="text-xs text-brand-ink mt-1 leading-relaxed">{c.detail}</div>
                </div>
              </motion.div>
            );
          })}
        </div>
        <div className="mt-10 border-t border-border pt-10" data-testid="regional-accreditations">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-ink mb-3">
                Altri accreditamenti regionali
              </div>
              <h3 className="font-heading font-bold text-2xl md:text-3xl tracking-tighter text-brand-black mb-6">
                Da Frosinone verso tutta Italia.
              </h3>
              <ul className="divide-y divide-border">
                {REGIONS.map((r) => (
                  <li key={r} className="py-2.5 flex items-center gap-3 text-sm text-brand-black">
                    <span className="w-2 h-2 rounded-full bg-brand-red shrink-0" />
                    {r}
                  </li>
                ))}
              </ul>
            </div>
            <ItalyRegionsMap />
          </div>
        </div>
      </div>
    </section>
  );
};
